import React, { Component } from 'react';

class ContentEducation extends Component {
    render() {
        return (
            <div className="row content-inside">
                <div className="col-lg-5 col-md-6 col-12 animate-element wow delay5 fadeInUp" data-wow-delay="0.5s">
                    <div className="experience-box t2 border-corner5 color-s1">
                        <div className="box-inner">
                        <h3 className="f-info color-d3">Universite of Udacity</h3>
                        <div className="s-info">User Experience Design</div>
                        <p>
                            User experience (UX) design is the process design teams use to create products. 
                        </p>
                    </div>
                </div>
                </div>
                <div className="col-lg-7 col-md-6 col-12 animate-element wow delay5 fadeInUp" data-wow-delay="0.6s">
                    <div className="col-right">
                        <div className="experience-box t2 border-corner5 color-s1">
                        <div className="box-inner">
                            <h3 className="f-info color-d3">2013-2015</h3>
                            <div className="s-info">UI Designer at Microsoft</div>
                            <p>
                            User experience (UX) design is the process design teams use to create products. 
                            </p>
                        </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-5 col-md-6 col-12 animate-element wow delay5 fadeInUp" data-wow-delay="0.7s">
                    <div className="experience-box t2 border-corner5 color-s2">
                        <div className="box-inner">
                        <h3 className="f-info color-d4">Udemy</h3>
                        <div className="s-info">Interaction Design</div>
                        <p>
                            User experience (UX) design is the process design teams use to create products. 
                        </p>
                        </div>
                    </div>
                </div>
                <div className="col-lg-7 col-md-6 col-12 animate-element wow delay5 fadeInUp" data-wow-delay="0.5s">
                    <div className="col-right">
                        <div className="experience-box t2 border-corner5 color-s2">
                        <div className="box-inner">
                            <h3 className="f-info color-d4">2015-2017</h3>
                            <div className="s-info">UX Designer at Apple</div>
                            <p>
                            User experience (UX) design is the process design teams use to create products. 
                            </p>
                        </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-5 col-md-6 col-12 animate-element wow delay5 fadeInUp" data-wow-delay="0.6s">
                    <div className="experience-box t2 border-corner5 color-s3">
                        <div className="box-inner">
                        <h3 className="f-info color-d5">Skill Share</h3>
                        <div className="s-info">Interaction Design</div>
                        <p>
                            User experience (UX) design is the process design teams use to create products. 
                        </p>
                        </div>
                    </div>
                </div>
                <div className="col-lg-7 col-md-6 col-12 animate-element wow delay5 fadeInUp" data-wow-delay="0.7s">
                    <div className="col-right">
                        <div className="experience-box t2 border-corner5 color-s3">
                        <div className="box-inner">
                            <h3 className="f-info color-d5">2017-2019</h3>
                            <div className="s-info">Product Designer at Earth</div>
                            <p>
                            User experience (UX) design is the process design teams use to create products. 
                            </p>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ContentEducation;
